import { useRef, useContext } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { INSERT_IMAGE_COMMAND } from './plugins/imageCommands';
import { ImageContext } from './MainEditor';
import { IMAGES } from '../../constants/images';

const UploadImageButton = () => {
  const [editor] = useLexicalComposerContext();
  const { addImage } = useContext(ImageContext);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const url = event.target?.result as string;
      addImage({ imageUrl: url, altText: '' }); 
      editor.dispatchCommand(INSERT_IMAGE_COMMAND, url);
    };

    reader.readAsDataURL(file);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        className="w-[135px] h-[40px] bg-[#587FE9] text-white rounded-md flex items-center justify-center gap-2"
      >
        <img src={IMAGES.camera} alt="카메라" className="w-5 h-5" />
        사진 추가
      </button>

      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        accept="image/*"
        onChange={handleUpload}
      />
    </div>
  );
};

export default UploadImageButton;
